module.exports = __webpack_public_path__ + "static/media/instazoom-logo-tr-white.9df10ffa.png";